import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaFilePdf, FaEnvelope, FaShareAlt, FaDatabase } from 'react-icons/fa';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 1.5rem;
`;

const ToolCard = styled(motion.button)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 1.25rem;
  border-radius: 14px;
  text-align: left;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-primary);
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--type-accent, var(--primary-color));
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 2px solid var(--type-accent, var(--primary-color));
    outline-offset: 2px;
  }
`;

const IconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--type-accent, var(--primary-color));
  color: #0C0F14;
  font-size: 1rem;
`;

const ToolTitle = styled.span`
  font-weight: 700;
  font-size: 0.95rem;
`;

const ToolDesc = styled.span`
  font-size: 0.82rem;
  color: var(--text-secondary);
  line-height: 1.45;
`;

const ResultsToolsGrid = ({ onExportPdf, onScrollToEmail, onScrollToShare, onScrollToBackup }) => (
  <Grid aria-label="Quick actions">
    <ToolCard type="button" onClick={onExportPdf} whileTap={{ scale: 0.98 }}>
      <IconWrap aria-hidden="true"><FaFilePdf /></IconWrap>
      <ToolTitle>Export PDF</ToolTitle>
      <ToolDesc>Forward to co-founder or advisor</ToolDesc>
    </ToolCard>
    <ToolCard type="button" onClick={onScrollToEmail} whileTap={{ scale: 0.98 }}>
      <IconWrap aria-hidden="true"><FaEnvelope /></IconWrap>
      <ToolTitle>Email report</ToolTitle>
      <ToolDesc>Operating profile to your inbox</ToolDesc>
    </ToolCard>
    <ToolCard type="button" onClick={onScrollToShare} whileTap={{ scale: 0.98 }}>
      <IconWrap aria-hidden="true"><FaShareAlt /></IconWrap>
      <ToolTitle>Share type</ToolTitle>
      <ToolDesc>Invite link for compare</ToolDesc>
    </ToolCard>
    <ToolCard type="button" onClick={onScrollToBackup} whileTap={{ scale: 0.98 }}>
      <IconWrap aria-hidden="true"><FaDatabase /></IconWrap>
      <ToolTitle>Backup data</ToolTitle>
      <ToolDesc>Save or restore locally</ToolDesc>
    </ToolCard>
  </Grid>
);

export default ResultsToolsGrid;
